var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-0",
    d: "M8.16,17.72a1,1,0,0,0,1.38.3l8.13-5.18a.89.89,0,0,0,.31-.3,1,1,0,0,0-.31-1.38l-3-1.88L9.54,6A1,1,0,0,0,9,5.82a1,1,0,0,0-1,1V17.18A1,1,0,0,0,8.16,17.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,16V6.82a1,1,0,0,1,1-1A1,1,0,0,1,9.54,6l5.18,3.3,7.69-7.69A2,2,0,0,0,21,1H3A2,2,0,0,0,1,3V21a2,2,0,0,0,.59,1.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.67,11.16A1,1,0,0,1,18,12.54a.89.89,0,0,1-.31.3L9.54,18a1,1,0,0,1-1.38-.3A1,1,0,0,1,8,17.18V16L1.59,22.41A2,2,0,0,0,3,23H21a2,2,0,0,0,2-2V3a2,2,0,0,0-.59-1.41L14.72,9.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridActive);
export default __webpack_public_path__ + "static/media/grid-active.1217c4c0430a5514398fcff31a58b558.svg";
export { ForwardRef as ReactComponent };